<app-back-to-signin *ngIf="!hideBackButton"></app-back-to-signin>

<div *ngIf="!appStore.$pageLoading() && signIn">
    <router-outlet></router-outlet>
</div>

<!-- <div *ngIf="appStore.$pageLoading()">
    <app-page-spin></app-page-spin>
</div> -->

<app-message></app-message>
<app-file-downloader></app-file-downloader>